export function isUrlWithProtocol(url: string) {
  return /^https?:\/\//.test(url);
}
